import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Stack,
  Paper,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import EngImg from "../../../images/Engineering-layout.png";

const Engineering = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Hero Banner */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "50vh", md: "70vh" },
          backgroundImage: `url(${EngImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
          }}
        />

        {/* Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 2,
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: "#fff",
              letterSpacing: 2,
              opacity: 0.9,
            }}
          >
            Specialization
          </Typography>

          <Typography
            variant="h3"

            sx={{
              color: "#fff",
              fontWeight: 700,
              mt: 1,
              mb: 2,
              fontWeight: 900,
              // fontSize: { xs: "2rem", md: "2.4rem" },
            }}
          >
            Engineering
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "rgba(255,255,255,0.85)",
              maxWidth: 600,
              mb: 3,
            }}
          >
            Delivering innovative and scalable engineering solutions powered by
            technology, precision, and industry expertise.
          </Typography>

          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              backgroundColor: "#1976d2",
              px: 4,
              py: 1.2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "15px",
              "&:hover": {
                backgroundColor: "#115293",
              },
            }}
            onClick={() => navigate("/contact-us")}
          >
            Get in Touch
          </Button>
        </Container>
      </Box>

      {/* Engineering Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },

            }}


          >
            Engineering Jobs
          </Typography>

          {/* Row 1 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Engineering Surveyor */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Surveyor
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Completion of accurate topographical surveys and construction
                  layouts of underground services, roads, grading, and
                  buildings. Preparation of survey notes, grade sheets and
                  calculations. Communicate with surveyors and contractors to
                  complete survey tasks. CAD drafting for civil engineering
                  projects, as needed.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* CAD Technologist - Land Development */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  CAD Technologist - Land Development
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Create preliminary and final approval drawings for a wide
                  variety of civil engineering projects for commercial,
                  industrial and residential clients. Prepare grading and
                  servicing plans, stormwater management plans, profiles,
                  sections and detail drawings, and coordinate with project team
                  members.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Environmental Technologist - Environmental Division */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                    mb: 2,
                  }}
                >
                  Environmental Technologist - Environmental Division
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Planning and conducting hazardous building material and indoor
                  air quality assessments. Conduct site work with monitoring of
                  hazardous materials abatement projects. Prepare inspection
                  reports, analytical result summaries and detailed technical
                  reports for clients and regulators.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Electrical Engineer */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Electrical Engineer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Experience using CAD for schematic capture and PCB layout
                  management. Work with lab equipment and measurement tools, and
                  support design, troubleshooting and optimization of electronic
                  systems across multiple applications.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 - 3 columns */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            {/* Mechanical Engineer */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Mechanical Engineer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Bachelor&apos;s degree in Mechanical Engineering with strong
                  proficiency in 3D design tools. Experience with mechanical
                  design using metals and composites, strong attention to
                  detail, and excellent organizational and communication skills.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Field Engineering Specialist */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Field Engineering Specialist
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Perform field surveys and RF safety studies, identify
                  equipment placement locations, conduct troubleshooting and
                  resolve interference issues. Serve as liaison between clients,
                  industry consultants and internal engineering staff.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Service Engineer */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Engineering
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Service Engineer
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Work with complex electro-mechanical systems, reliability
                  testing and quality measurement methods. Analyze data, create
                  actionable results, and support customers with technical
                  troubleshooting and on-site service.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Engineering;
